namespace GeniuzPOS.Purchase {
@Serenity.Decorators.registerClass()
export class PoPo06DtPendingCNforCnrtvEditor extends Serenity.Extensions.GridEditorBase<PoPo06DtPendingCNforCnrtvRow> {
    protected getColumnsKey() { return PoPo06DtPendingCNforCnrtvColumns.columnsKey; }
    protected getDialogType() { return PoPo06DtPendingCNforCnrtvDialog; }
    protected getLocalTextPrefix() { return PoPo06DtPendingCNforCnrtvRow.localTextPrefix; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
        
       
        return buttons;
    }



    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

    protected usePager() {
        return false;
    }

    
}}